var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "d-flex flex-column justify-center align-center"
    },
    [
      _c(
        "h3",
        {
          staticClass: "h2 mb-4 mt-4"
        },
        [_vm._v("All set! Let's go!")]
      ),
      _c(
        "gg-btn",
        {
          staticClass: "mb-4",
          attrs: {
            loading: _vm.loading
          },
          on: {
            click: _vm.login
          }
        },
        [_vm._v("WP-Admin Dashboard")]
      ),
      _c(
        "gg-btn",
        {
          attrs: {
            text: ""
          },
          on: {
            click: function click($event) {
              return _vm.$emit("skip")
            }
          }
        },
        [_vm._v("Skip for now")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }